import { useAuth } from "@/context/AuthContext";
import { isProductEnabled, PRODUCT_CATALOG } from "@/lib/productCatalog";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";

// Blocca l'accesso diretto via URL a un prodotto non abilitato per il Partner.
export function ProductGuard({ code, children }) {
  const { user } = useAuth();
  if (isProductEnabled(user, code)) return children;
  const label = PRODUCT_CATALOG[code]?.label || "Questo prodotto";
  return (
    <div className="mx-auto flex max-w-lg flex-col items-center justify-center py-20 text-center" data-testid="product-not-enabled">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-terracotta/10">
        <Lock className="h-7 w-7 text-terracotta" />
      </div>
      <h2 className="mt-5 font-heading text-2xl font-semibold text-forest">Prodotto non abilitato per il tuo profilo</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        «{label}» non è tra i prodotti abilitati per il tuo profilo. Contatta l'Agenzia per richiederne l'attivazione.
      </p>
      <Link to="/" className="mt-6"><Button variant="outline" data-testid="product-guard-home">Torna alla Home</Button></Link>
    </div>
  );
}
